
import { Modal, Row } from "react-bootstrap";
import close from "../../../Assets/images/cross_icon.png";
import styles from "./index.module.scss";
import { useDispatch } from "react-redux";
import CommonButton from "components/Common/CommonButton";

const TaskCompletePop = ({
  showPopup,
  setShowPopup,
  closePopup,
  onClick
}) => { 
  const handleSubmit = (values, { setSubmitting }) => {
    onClick?.()
    setSubmitting(false);
    setShowPopup(false)
  };

  return (
    <Modal
      show={showPopup}
      className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop`}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      centered
      size="sm"
    >
      <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
        <div className="reports-v2">
          <div
            className="section-title d-flex align-items-center justify-content-between"
            style={{ borderColor: "#315D99" }}
          >
            <h6
              className="mb-0 section-title border-bottom-0"
              style={{ color: "#93278F" }}
            >
              ARE YOU SURE?
            </h6>

            <img
              onClick={closePopup}
              width={16}
              height={16}
              src={close}
              alt="close"
              style={{ cursor: "pointer" }}
            />
          </div>

          <Row>
            <p className="support-staff-description">
              <strong className="fst-italic">Mark as Complete</strong> will close this task plan and you will no longer be able to track sessions for this client and plan.
            </p>
          </Row>

          <div className="d-flex justify-content-center gap-2 mt-4">
            <CommonButton
              text="Cancel"
              onClick={() => setShowPopup(false)}
              className="staff-button-outlined"
            />

            <CommonButton
              text="Continue"
              className="staff-button-filled"
              onClick={() => {
                onClick?.();   // call parent formik submit
                setShowPopup(false);
              }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TaskCompletePop;